module.exports = __webpack_public_path__ + "static/media/yellowalert.d2a08041.svg";